import { RFIQuickLinks } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Quick Link'
const page = RFIQuickLinks

const quickLinks = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '15952EA1-38F6-43F0-91B6-F49CADD31BE7',
  view: 'A74BF8F6-9B74-4E68-B5BD-B43A8FC6F607',
  edit: '8161F119-0568-48C6-9641-9DCDD5F99811',
  removeRestore: '5909D4B9-7058-4106-B850-8A1573A586D3',
})

export const CreateRFIQuickLink = quickLinks.Create
export const ViewRFIQuickLink = quickLinks.View
export const EditRFIQuickLink = quickLinks.Edit
export const RemoveRestoreRFIQuickLink = quickLinks.RemoveRestore

export type RFIQuickLinkPermission =
  | typeof CreateRFIQuickLink
  | typeof ViewRFIQuickLink
  | typeof EditRFIQuickLink
  | typeof RemoveRestoreRFIQuickLink
